let theLocale;

export function setLocale(locale) {
  theLocale = locale;
}

export function getLocale() {
  return theLocale;
}



// WEBPACK FOOTER //
// ./app/javascript/mastodon/locales/index.js